import { type Location } from '../../../../machine';

/**
 * A small hook that returns a boolean indicating if fee disclosure should
 * be displayed.
 */
export const useLocationResultsFeeDisclosure = (params: UseLocationResultsFeeDisclosureParams) => {
  const { location } = params;

  const {
    showDeliveryPriceDifferenciationDisclosure = false,
    outpostPriceDifferentiationEnabled = false,
    isOutpost: isOutpostLocation = false,
    isDelivery: isDeliveryLocation = false,
  } = location ?? {};

  const shouldShowDeliveryFeeDisclaimer =
    isDeliveryLocation && showDeliveryPriceDifferenciationDisclosure;
  const shouldShowOutpostFeeDisclaimer = isOutpostLocation && outpostPriceDifferentiationEnabled;

  return {
    shouldShowDeliveryFeeDisclaimer,
    shouldShowOutpostFeeDisclaimer,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseLocationResultsFeeDisclosureParams = {
  location?: Pick<
    Location,
    | 'showDeliveryPriceDifferenciationDisclosure'
    | 'outpostPriceDifferentiationEnabled'
    | 'isDelivery'
    | 'isOutpost'
    | 'addressId'
  >;
  locationSearchType?: string;
};
